<template>
	<div class="cb86951c">
		<div class="cddfb2ed"></div>
		<div class="c3ecdb44">
			<div class="dc04ec1d" :class="navSta?'':'a02af2e6'">
				<!-- 左侧导航栏未隐藏时显示 -->
				<div class="b8812f16 a2f3d50e" v-if="navSta">
					<div class="_6969ec9">
						<div class="a5967822"></div>
						<div class="e066abb8">
							<img src="../../assets/pcLogo.png" style="height: 50px;">
						</div>
						<!-- <div class="ds-icon-button _7d1f5e2" tabindex="0" style="--ds-icon-button-size: 28px;"></div> -->
						<div class="ds-icon-button _7d1f5e2" @click="navSta=!navSta" tabindex="0" style="--ds-icon-button-size: 28px;">
							<svg viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"><defs><clipPath id="clip1382_20239"><rect id="折叠边栏0730" width="30.000000" height="30.000000" fill="white" fill-opacity="0"></rect></clipPath></defs><rect id="折叠边栏0730" width="30.000000" height="30.000000" fill="#FFFFFF" fill-opacity="0"></rect><g clip-path="url(#clip1382_20239)"><rect id="rect" x="17.420410" y="12.316406" rx="1.000947" width="5.995172" height="2.001895" transform="rotate(137.159 17.420410 12.316406)" fill="currentColor" fill-opacity="1.000000"></rect><rect id="rect" x="12.959473" y="13.728516" rx="0.995190" width="6.002943" height="1.990380" transform="rotate(40.853 12.959473 13.728516)" fill="currentColor" fill-opacity="1.000000"></rect><path id="path" d="M20.1 25.5L9.9 25.51C9.48 25.51 9.06 25.47 8.65 25.39C8.24 25.3 7.84 25.18 7.45 25.02C7.06 24.86 6.69 24.66 6.34 24.43C5.99 24.19 5.67 23.92 5.37 23.63C5.07 23.33 4.81 23 4.58 22.65C4.34 22.3 4.15 21.93 3.98 21.54C3.82 21.15 3.7 20.75 3.62 20.34C3.54 19.93 3.5 19.51 3.5 19.09L3.5 10.93C3.5 10.51 3.54 10.1 3.62 9.68C3.7 9.27 3.82 8.87 3.98 8.48C4.15 8.09 4.34 7.72 4.58 7.37C4.81 7.02 5.07 6.69 5.37 6.39C5.67 6.1 5.99 5.83 6.34 5.6C6.69 5.36 7.06 5.16 7.45 5C7.84 4.84 8.24 4.72 8.65 4.64C9.06 4.55 9.48 4.51 9.9 4.51L20.1 4.5C20.52 4.5 20.94 4.54 21.35 4.62C21.76 4.7 22.16 4.83 22.55 4.99C22.94 5.15 23.31 5.35 23.66 5.58C24 5.82 24.33 6.08 24.62 6.38C24.92 6.68 25.19 7 25.42 7.35C25.65 7.7 25.85 8.07 26.01 8.46C26.17 8.85 26.3 9.25 26.38 9.67C26.46 10.08 26.5 10.5 26.5 10.92L26.5 19.07C26.5 19.5 26.46 19.91 26.38 20.32C26.3 20.74 26.17 21.14 26.01 21.53C25.85 21.92 25.65 22.29 25.42 22.64C25.19 22.99 24.92 23.31 24.62 23.61C24.33 23.91 24 24.17 23.66 24.41C23.31 24.64 22.94 24.84 22.55 25C22.16 25.16 21.76 25.29 21.35 25.37C20.94 25.45 20.52 25.5 20.1 25.5ZM9.9 6.6C9.61 6.6 9.33 6.63 9.05 6.69C8.78 6.74 8.51 6.82 8.24 6.93C7.98 7.04 7.73 7.18 7.5 7.33C7.26 7.49 7.04 7.67 6.84 7.87C6.64 8.07 6.46 8.29 6.31 8.53C6.15 8.77 6.02 9.01 5.91 9.28C5.8 9.54 5.72 9.81 5.66 10.09C5.61 10.37 5.58 10.65 5.58 10.93L5.58 19.09C5.58 19.37 5.61 19.65 5.66 19.93C5.72 20.21 5.8 20.48 5.91 20.74C6.02 21.01 6.15 21.26 6.31 21.49C6.46 21.73 6.64 21.95 6.84 22.15C7.04 22.35 7.26 22.53 7.5 22.69C7.73 22.85 7.98 22.98 8.24 23.09C8.51 23.2 8.78 23.28 9.05 23.33C9.33 23.39 9.61 23.42 9.9 23.42L20.1 23.41C20.38 23.41 20.67 23.37 20.94 23.32C21.22 23.26 21.49 23.18 21.75 23.07C22.01 22.96 22.26 22.83 22.5 22.67C22.73 22.51 22.95 22.33 23.15 22.13C23.35 21.93 23.53 21.71 23.69 21.48C23.85 21.24 23.98 20.99 24.09 20.73C24.2 20.47 24.28 20.2 24.33 19.92C24.39 19.64 24.42 19.36 24.42 19.07L24.42 10.92C24.42 10.64 24.39 10.35 24.33 10.07C24.28 9.79 24.2 9.52 24.09 9.26C23.98 9 23.85 8.75 23.69 8.51C23.53 8.28 23.35 8.06 23.15 7.86C22.95 7.66 22.73 7.48 22.5 7.32C22.26 7.16 22.01 7.03 21.75 6.92C21.49 6.81 21.22 6.73 20.94 6.67C20.67 6.62 20.38 6.59 20.1 6.59L9.9 6.6Z" fill="currentColor" fill-opacity="1.000000" fill-rule="nonzero"></path><path id="rect" d="M8.5 5.51L10.54 5.51L10.6 24.43L8.55 24.43L8.5 5.51Z" fill="currentColor" fill-opacity="1.000000" fill-rule="evenodd"></path></g></svg>
						</div>
						<div class="ds-icon _8a9564e" style="font-size: 24px; width: 24px; height: 24px;"></div>
					</div>
					<div class="ebaea5d2">
						<div class="_5a8ac7a">
							<div class="c7dddcde" @click="newChat">
								<div class="_1c42ad7"></div>开启新对话
							</div>
						</div>
					</div>
					<div class="_03210fb">
						<div class="_196bcac">
							<div class="_68953bc">
								<div class="ds-skeleton ds-skeleton--m ds-skeleton--text _5c2e5a9"><span
										aria-hidden="true">&nbsp;</span></div>
							</div>
							<div class="_68953bc">
								<div class="ds-skeleton ds-skeleton--m ds-skeleton--text _5c2e5a9"><span
										aria-hidden="true">&nbsp;</span></div>
							</div>
							<div class="_68953bc">
								<div class="ds-skeleton ds-skeleton--m ds-skeleton--text _5c2e5a9"><span
										aria-hidden="true">&nbsp;</span></div>
							</div>
							<div class="_68953bc">
								<div class="ds-skeleton ds-skeleton--m ds-skeleton--text _5c2e5a9"><span
										aria-hidden="true">&nbsp;</span></div>
							</div>
						</div>
						<div class="_77cdc67 _8a693f3">

							<div class="_5d4b535" v-for="(item,index) in hisList" :key="index">
								<div class="_48cdfc1">{{item.create_time}}</div>
								<div class="_83421f9" tabindex="0">
									<div class="c08e6e93" @click="getChatDet(item.chat_id,item.msg)">{{item.msg}}</div>
									<div class="_2090548" tabindex="0">
										<div class="ds-icon" style="font-size: 12px;"
											@click="deleChat(item.chat_id,index)">删除</div>
									</div>
								</div>
								<div class="b9cb4a74"></div>
							</div>
						</div>
					</div>
					<div class="c7f51894">
						<!-- <div class="a1e75851">
							<div class="ds-icon" style="font-size: 20px; width: 20px; height: 20px; margin-right: 8px;">
							</div>下载 App<span class="_106b9f9"></span>
						</div> -->
						<!-- <div class="c6ab9234">
							<div class="ede5bc47"><img class="fdf01f38" :src="headImg" alt="" aria-hidden="true"></div>
							<div class="_7d65532">{{userName}}</div>
						</div> -->
						<a-dropdown>
							<div class="c6ab9234" @click.prevent>
								<div class="ede5bc47"><img class="fdf01f38" :src="headImg" alt="" aria-hidden="true"></div>
								<div class="_7d65532">{{userName}}</div>
							</div>
						    <template #overlay>
						      <a-menu>
						        <a-menu-item>
						          <a href="javascript:;" @click="loginOut">退出登录</a>
						        </a-menu-item>
						      </a-menu>
						    </template>
						</a-dropdown>
					</div>
				</div>
				<!-- 隐藏时显示 -->
				<div class="a7f3a288 f0d4f23d" v-if="!navSta">
					<div class="ds-icon" style="font-size: 44px; width: 44px; height: 44px; cursor: pointer;">
						<img src="https://ai.iptzx.com/static/logo.png" style="width: 100%;height: 100%;">
					</div>
					<div style="margin-top: 38px; display: flex;" @click="navSta=!navSta">
						<div class="ds-icon-button" tabindex="0" style="--ds-icon-button-size: 28px;"><svg
								viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg"
								xmlns:xlink="http://www.w3.org/1999/xlink">
								<defs>
									<clipPath id="clip1381_20236">
										<rect id="打开边栏0730" width="30.000000" height="30.000000" fill="white"
											fill-opacity="0"></rect>
									</clipPath>
								</defs>
								<rect id="打开边栏0730" width="30.000000" height="30.000000" fill="#FFFFFF"
									fill-opacity="0"></rect>
								<g clip-path="url(#clip1381_20236)">
									<rect id="rect" x="11.572754" y="17.683594" rx="1.000947" width="5.995172"
										height="2.001895" transform="rotate(-42.841 11.572754 17.683594)"
										fill="currentColor" fill-opacity="1.000000"></rect>
									<rect id="rect" x="16.033691" y="16.271484" rx="0.995190" width="6.002943"
										height="1.990380" transform="rotate(-139.147 16.033691 16.271484)"
										fill="currentColor" fill-opacity="1.000000"></rect>
									<path id="path"
										d="M20.09 25.48L9.89 25.5C9.47 25.5 9.05 25.45 8.64 25.37C8.23 25.29 7.83 25.17 7.44 25C7.05 24.84 6.68 24.64 6.33 24.41C5.98 24.18 5.66 23.91 5.36 23.61C5.07 23.31 4.8 22.99 4.57 22.64C4.34 22.29 4.14 21.92 3.98 21.53C3.82 21.14 3.69 20.74 3.61 20.32C3.53 19.91 3.49 19.49 3.49 19.07L3.49 10.92C3.49 10.5 3.53 10.08 3.61 9.67C3.69 9.25 3.82 8.85 3.98 8.46C4.14 8.07 4.34 7.7 4.57 7.35C4.8 7 5.07 6.68 5.36 6.38C5.66 6.08 5.98 5.81 6.33 5.58C6.68 5.35 7.05 5.15 7.44 4.99C7.83 4.82 8.23 4.7 8.64 4.62C9.05 4.54 9.47 4.5 9.89 4.5L20.09 4.48C20.51 4.48 20.93 4.52 21.34 4.6C21.75 4.69 22.15 4.81 22.54 4.97C22.93 5.13 23.3 5.33 23.65 5.57C24 5.8 24.32 6.06 24.62 6.36C24.92 6.66 25.18 6.98 25.41 7.33C25.65 7.69 25.84 8.06 26.01 8.45C26.17 8.84 26.29 9.24 26.37 9.65C26.45 10.06 26.49 10.48 26.5 10.91L26.5 19.06C26.49 19.48 26.45 19.89 26.37 20.31C26.29 20.72 26.17 21.12 26.01 21.51C25.84 21.9 25.65 22.27 25.41 22.62C25.18 22.97 24.92 23.3 24.62 23.6C24.32 23.89 24 24.16 23.65 24.39C23.3 24.63 22.93 24.83 22.54 24.99C22.15 25.15 21.75 25.27 21.34 25.35C20.93 25.44 20.51 25.48 20.09 25.48ZM9.89 6.59C9.61 6.59 9.32 6.62 9.05 6.67C8.77 6.73 8.5 6.81 8.24 6.92C7.98 7.03 7.73 7.16 7.49 7.32C7.26 7.48 7.04 7.66 6.84 7.86C6.64 8.06 6.46 8.28 6.3 8.51C6.14 8.75 6.01 9 5.9 9.26C5.79 9.52 5.71 9.8 5.66 10.07C5.6 10.35 5.57 10.63 5.57 10.92L5.57 19.07C5.57 19.36 5.6 19.64 5.66 19.92C5.71 20.19 5.79 20.47 5.9 20.73C6.01 20.99 6.14 21.24 6.3 21.48C6.46 21.71 6.64 21.93 6.84 22.13C7.04 22.33 7.26 22.51 7.49 22.67C7.73 22.83 7.98 22.96 8.24 23.07C8.5 23.18 8.77 23.26 9.05 23.32C9.32 23.37 9.61 23.4 9.89 23.4L20.09 23.39C20.38 23.39 20.66 23.36 20.94 23.3C21.21 23.25 21.48 23.17 21.75 23.06C22.01 22.95 22.26 22.81 22.49 22.66C22.73 22.5 22.95 22.32 23.15 22.12C23.35 21.91 23.52 21.7 23.68 21.46C23.84 21.22 23.97 20.98 24.08 20.71C24.19 20.45 24.27 20.18 24.33 19.9C24.38 19.62 24.41 19.34 24.41 19.06L24.41 10.91C24.41 10.62 24.38 10.34 24.33 10.06C24.27 9.78 24.19 9.51 24.08 9.25C23.97 8.98 23.84 8.74 23.68 8.5C23.52 8.26 23.35 8.04 23.15 7.84C22.95 7.64 22.73 7.46 22.49 7.3C22.26 7.15 22.01 7.01 21.75 6.9C21.48 6.79 21.21 6.71 20.94 6.66C20.66 6.6 20.38 6.57 20.09 6.57L9.89 6.59Z"
										fill="currentColor" fill-opacity="1.000000" fill-rule="nonzero"></path>
									<path id="rect" d="M8.49 5.5L10.53 5.5L10.59 24.41L8.54 24.41L8.49 5.5Z"
										fill="currentColor" fill-opacity="1.000000" fill-rule="evenodd"></path>
								</g>
							</svg></div>
					</div>
					<div style="margin-top: 38px; display: flex;" @click="newChat">
						<div class="ds-icon-button" tabindex="0" style="--ds-icon-button-size: 28px;"><svg
								viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg"
								xmlns:xlink="http://www.w3.org/1999/xlink">
								<defs>
									<clipPath id="clip1325_20400">
										<rect id="新建会话0730" width="30.000000" height="30.000000" fill="white"
											fill-opacity="0"></rect>
									</clipPath>
								</defs>
								<g clip-path="url(#clip1325_20400)">
									<path id="path"
										d="M10.51 26.52C10.35 26.52 10.19 26.49 10.04 26.43C9.89 26.37 9.76 26.28 9.64 26.17C9.53 26.06 9.44 25.93 9.37 25.78C9.31 25.63 9.28 25.48 9.28 25.32L9.25 22.87C8.89 22.82 8.53 22.74 8.19 22.62C7.84 22.5 7.51 22.36 7.19 22.19C6.86 22.01 6.56 21.81 6.28 21.58C5.99 21.36 5.73 21.11 5.49 20.83C5.25 20.56 5.04 20.27 4.85 19.96C4.67 19.65 4.51 19.33 4.38 18.99C4.25 18.65 4.16 18.3 4.09 17.95C4.03 17.6 4 17.24 4 16.88L4 10.38C4 9.99 4.03 9.6 4.11 9.21C4.19 8.82 4.31 8.45 4.46 8.08C4.61 7.72 4.8 7.37 5.03 7.04C5.25 6.72 5.5 6.41 5.78 6.13C6.07 5.86 6.38 5.61 6.71 5.39C7.04 5.17 7.4 4.98 7.77 4.83C8.14 4.68 8.52 4.57 8.91 4.49C9.31 4.41 9.7 4.38 10.11 4.38L14.35 4.38C14.5 4.38 14.63 4.4 14.77 4.46C14.9 4.51 15.02 4.59 15.12 4.69C15.22 4.79 15.3 4.9 15.35 5.03C15.41 5.16 15.43 5.3 15.43 5.44C15.43 5.58 15.41 5.71 15.35 5.84C15.3 5.97 15.22 6.09 15.12 6.19C15.02 6.29 14.9 6.37 14.77 6.42C14.63 6.47 14.5 6.5 14.35 6.5L10.11 6.5C9.85 6.5 9.59 6.53 9.34 6.58C9.08 6.62 8.83 6.7 8.6 6.8C8.36 6.89 8.13 7.01 7.91 7.15C7.7 7.3 7.5 7.46 7.31 7.64C7.13 7.82 6.97 8.01 6.82 8.22C6.68 8.44 6.56 8.66 6.46 8.9C6.36 9.13 6.28 9.37 6.23 9.62C6.18 9.87 6.16 10.12 6.16 10.38L6.16 16.88C6.16 17.14 6.18 17.39 6.23 17.65C6.29 17.9 6.36 18.15 6.46 18.39C6.56 18.62 6.69 18.85 6.83 19.07C6.98 19.28 7.15 19.48 7.33 19.66C7.52 19.85 7.72 20.01 7.94 20.15C8.16 20.3 8.39 20.42 8.63 20.52C8.87 20.62 9.13 20.69 9.38 20.74C9.64 20.79 9.9 20.82 10.17 20.82C10.33 20.82 10.49 20.85 10.64 20.91C10.79 20.97 10.92 21.06 11.04 21.17C11.15 21.28 11.24 21.41 11.31 21.56C11.37 21.71 11.4 21.86 11.41 22.02L11.42 23.53L14.15 21.56C14.85 21.07 15.62 20.82 16.48 20.82L19.87 20.82C20.13 20.82 20.38 20.79 20.64 20.74C20.89 20.69 21.14 20.62 21.38 20.52C21.62 20.42 21.85 20.3 22.06 20.16C22.28 20.02 22.48 19.86 22.66 19.68C22.84 19.5 23.01 19.3 23.15 19.09C23.29 18.88 23.42 18.66 23.52 18.42C23.61 18.19 23.69 17.94 23.74 17.69C23.79 17.44 23.82 17.19 23.82 16.94L23.82 13.58C23.82 13.44 23.84 13.3 23.9 13.17C23.95 13.04 24.03 12.93 24.13 12.83C24.23 12.73 24.35 12.65 24.48 12.6C24.62 12.54 24.75 12.52 24.9 12.52C25.04 12.52 25.18 12.54 25.31 12.6C25.44 12.65 25.56 12.73 25.66 12.83C25.76 12.93 25.84 13.04 25.9 13.17C25.95 13.3 25.98 13.44 25.98 13.58L25.98 16.94C25.98 17.33 25.94 17.72 25.86 18.11C25.78 18.5 25.67 18.87 25.51 19.24C25.36 19.6 25.17 19.95 24.95 20.27C24.73 20.6 24.47 20.9 24.19 21.18C23.9 21.46 23.6 21.71 23.26 21.93C22.93 22.15 22.58 22.33 22.21 22.48C21.83 22.63 21.45 22.75 21.06 22.83C20.67 22.9 20.27 22.94 19.87 22.94L17.19 22.94C16.33 22.94 15.56 23.19 14.86 23.69L11.24 26.29C11.02 26.44 10.78 26.52 10.51 26.52Z"
										fill="currentColor" fill-opacity="1.000000" fill-rule="nonzero"></path>
									<rect id="rect" x="17.770508" y="6.396484" rx="1.062250" width="8.060087"
										height="2.124500" fill="currentColor" fill-opacity="1.000000"></rect>
									<rect id="rect" x="20.718750" y="3.500000" rx="1.081197" width="2.162393"
										height="7.918844" fill="currentColor" fill-opacity="1.000000"></rect>
								</g>
							</svg></div>
					</div>
					<div style="flex: 1 1 0%;"></div>
					<div class="_41b9122">
						<div class="ds-icon" style="font-size: 28px; width: 28px; height: 28px;"><svg
								viewBox="0 0 1024 1024" xmlns="http://www.w3.org/2000/svg" width="300" height="300">
								<path
									d="M725.333 1024H298.667a128 128 0 0 1-128-128V128a128 128 0 0 1 128-128h426.666a128 128 0 0 1 128 128v768a128 128 0 0 1-128 128zM298.667 85.333A42.667 42.667 0 0 0 256 128v768a42.667 42.667 0 0 0 42.667 42.667h426.666A42.667 42.667 0 0 0 768 896V128a42.667 42.667 0 0 0-42.667-42.667z"
									fill="currentColor"></path>
								<path
									d="M469.33299999999997 853.333a42.667 42.667 0 1 0 85.334 0 42.667 42.667 0 1 0-85.334 0zM554.667 213.333h-85.334a42.667 42.667 0 0 1 0-85.333h85.334a42.667 42.667 0 0 1 0 85.333z"
									fill="currentColor"></path>
							</svg></div>
					</div>
					<div class="ede5bc47"><img class="fdf01f38"
							:src="headImg"
							alt="" aria-hidden="true"></div>
				</div>
			</div>
			<div class="_4cbcd96" :class="navSta?'':'_7d10bb1'" @click="navSta=!navSta"></div>
			<div class="_7780f2e">
				<!-- 新对话页面中间位置显示 -->
				<div class="_765a5cd" v-if="talkList==''">
					<div class="_660ca72">
						<div class="_2be88ba _1551317">
							<div class="f8d1e4c0">
								<div class="_62b4800"></div>
							</div>
							<div class="_0efe408">
								<div class="ds-icon d7829b2f _2e7d873" @click="navSta=!navSta" style="font-size: 24px; width: 32px; height: 32px; color: rgb(139, 139, 139);"><svg width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M23.7222 4H4.27776C3.57207 4 3 4.57207 3 5.27776C3 5.98345 3.57207 6.55553 4.27776 6.55553H23.7222C24.4279 6.55553 25 5.98345 25 5.27776C25 4.57207 24.4279 4 23.7222 4Z" fill="currentColor"></path><path d="M14.7593 12.8887H4.27776C3.57207 12.8887 3 13.4607 3 14.1664C3 14.8721 3.57207 15.4442 4.27776 15.4442H14.7593C15.465 15.4442 16.037 14.8721 16.037 14.1664C16.037 13.4607 15.465 12.8887 14.7593 12.8887Z" fill="currentColor"></path><path d="M23.7222 21.7334H4.27776C3.57207 21.7334 3 22.3055 3 23.0112C3 23.7169 3.57207 24.2889 4.27776 24.2889H23.7222C24.4279 24.2889 25 23.7169 25 23.0112C25 22.3055 24.4279 21.7334 23.7222 21.7334Z" fill="currentColor"></path></svg></div>
								<div class="ds-icon d7829b2f _23ecf90" @click="newChat" style="font-size: 24px; width: 32px; height: 32px; color: rgb(139, 139, 139);"><svg width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M9.10999 27C8.92999 27 8.76001 26.96 8.60001 26.9C8.43001 26.83 8.29 26.74 8.16 26.61C8.03 26.49 7.94 26.3499 7.87 26.1899C7.79999 26.0299 7.76001 25.8599 7.76001 25.6899L7.73001 23.04C7.34001 22.98 6.95001 22.8799 6.57001 22.7599C6.19001 22.6299 5.83001 22.48 5.48001 22.29C5.13001 22.1 4.79999 21.88 4.48999 21.63C4.17999 21.39 3.89 21.1199 3.63 20.82C3.37 20.52 3.13999 20.21 2.92999 19.87C2.72999 19.53 2.56001 19.18 2.42001 18.82C2.28001 18.45 2.17001 18.07 2.10001 17.69C2.03001 17.3 2 16.92 2 16.53V9.46995C2 9.03995 2.04 8.61995 2.12 8.19995C2.21 7.77995 2.34 7.36995 2.5 6.96995C2.67 6.57995 2.88 6.19995 3.12 5.84995C3.36 5.48995 3.64001 5.15995 3.95001 4.85995C4.26001 4.55995 4.59999 4.28995 4.95999 4.04995C5.32999 3.80995 5.70999 3.60995 6.10999 3.44995C6.51999 3.27995 6.94 3.15995 7.37 3.07995C7.79999 2.98995 8.23001 2.94995 8.67001 2.94995H13.3C13.46 2.94995 13.61 2.97995 13.76 3.03995C13.9 3.09995 14.03 3.17995 14.14 3.28995C14.25 3.39995 14.33 3.51995 14.39 3.65995C14.45 3.79995 14.48 3.94995 14.48 4.09995C14.48 4.25995 14.45 4.39995 14.39 4.54995C14.33 4.68995 14.25 4.80995 14.14 4.91995C14.03 5.02995 13.9 5.10995 13.76 5.16995C13.61 5.22995 13.46 5.25995 13.3 5.25995H8.67001C8.38001 5.25995 8.09999 5.27995 7.82999 5.33995C7.54999 5.38995 7.27999 5.46995 7.01999 5.57995C6.75999 5.67995 6.50999 5.80995 6.26999 5.96995C6.03999 6.11995 5.82 6.29995 5.62 6.48995C5.42 6.68995 5.23999 6.89995 5.07999 7.12995C4.92999 7.35995 4.78999 7.59995 4.67999 7.85995C4.57999 8.10995 4.49 8.37995 4.44 8.64995C4.38 8.91995 4.35999 9.18995 4.35999 9.46995V16.53C4.35999 16.81 4.38 17.08 4.44 17.36C4.5 17.63 4.58 17.9 4.69 18.16C4.8 18.42 4.93 18.67 5.09 18.9C5.25 19.13 5.43001 19.3499 5.64001 19.5499C5.84001 19.75 6.05999 19.92 6.29999 20.08C6.53999 20.24 6.79 20.37 7.06 20.47C7.32 20.58 7.6 20.66 7.88 20.72C8.16001 20.77 8.44001 20.7999 8.73001 20.7999C8.91001 20.7999 9.08 20.83 9.25 20.9C9.41 20.97 9.55999 21.0599 9.67999 21.18C9.80999 21.3099 9.91001 21.45 9.98001 21.61C10.05 21.77 10.08 21.94 10.09 22.11L10.1 23.74L13.08 21.61C13.84 21.07 14.69 20.7999 15.63 20.7999H19.32C19.61 20.7999 19.89 20.77 20.16 20.72C20.44 20.67 20.71 20.59 20.97 20.4799C21.23 20.3699 21.48 20.24 21.72 20.09C21.95 19.94 22.17 19.76 22.37 19.57C22.57 19.3699 22.75 19.16 22.91 18.93C23.07 18.7 23.2 18.46 23.31 18.2C23.41 17.95 23.5 17.68 23.55 17.41C23.61 17.14 23.63 16.87 23.63 16.59V12.94C23.63 12.79 23.66 12.64 23.72 12.5C23.78 12.36 23.87 12.23 23.98 12.13C24.09 12.02 24.22 11.93 24.36 11.88C24.51 11.82 24.66 11.79 24.82 11.79C24.97 11.79 25.12 11.82 25.27 11.88C25.41 11.93 25.54 12.02 25.65 12.13C25.76 12.23 25.85 12.36 25.91 12.5C25.97 12.64 26 12.79 26 12.94V16.59C26 17.02 25.95 17.44 25.87 17.86C25.78 18.28 25.66 18.69 25.49 19.08C25.32 19.48 25.11 19.8499 24.87 20.2099C24.63 20.57 24.35 20.9 24.04 21.2C23.73 21.5 23.39 21.7699 23.03 22.0099C22.67 22.2499 22.28 22.45 21.88 22.61C21.47 22.77 21.06 22.9 20.63 22.9799C20.2 23.07 19.76 23.11 19.32 23.11H16.4C15.47 23.11 14.62 23.3799 13.86 23.9199L9.91 26.74C9.67 26.91 9.39999 27 9.10999 27Z" fill="currentColor"></path><path d="M24.6805 5.14453H18.1874C17.5505 5.14453 17.0342 5.66086 17.0342 6.29778C17.0342 6.9347 17.5505 7.45102 18.1874 7.45102H24.6805C25.3175 7.45102 25.8338 6.9347 25.8338 6.29778C25.8338 5.66086 25.3175 5.14453 24.6805 5.14453Z" fill="currentColor"></path><path d="M22.6137 3.1804C22.6137 2.52848 22.0852 2 21.4333 2C20.7814 2 20.2529 2.52848 20.2529 3.1804V9.4168C20.2529 10.0687 20.7814 10.5972 21.4333 10.5972C22.0852 10.5972 22.6137 10.0687 22.6137 9.4168V3.1804Z" fill="currentColor"></path></svg></div></div>
						</div>
						<div class="_9a2f8e4">
							<div class="_5758a85">
								<div class="_6c7e7df">
									<div class="ds-icon da6cda9a" style="font-size: 60px; width: 60px; height: 60px;">
									</div>我是 顶搜，很高兴见到你！
								</div>
								<div class="_9a8d0e1">我可以帮你写代码、读文件、写作各种创意内容，请把你的任务交给我吧~</div>
							</div>
							<div class="aaff8b8f eb830e32">
								<div class="_77cefa5">
									<div class="dd442025 _42b6996">
										<div class="_24fad49">
											<textarea id="chat-input" class="_27c9245" @keydown.enter="textEnter" placeholder="给 顶搜 发送消息 " v-model="content" rows="2"></textarea>
											<div class="b13855df">
											</div>
										</div>
										<div class="ec4f5d61">
											<div class="bf38813a">
												<!-- <div class="f02f0e25">
													<div class="ds-icon"
														style="font-size: 23px; width: 23px; height: 23px;"></div>
												</div> -->
												<div role="button" aria-disabled="true" class="_7436101"
													:class="content!=''?'':'bcc55ca1'" @click="newOpen">
													<div class="_6f28693">
														<div class="ds-icon"
															style="font-size: 16px; width: 16px; height: 16px;">
															<svg width="14" height="16" viewBox="0 0 14 16"
																fill="none" xmlns="http://www.w3.org/2000/svg">
																<path fill-rule="evenodd" clip-rule="evenodd"
																	d="M7 16c-.595 0-1.077-.462-1.077-1.032V1.032C5.923.462 6.405 0 7 0s1.077.462 1.077 1.032v13.936C8.077 15.538 7.595 16 7 16z"
																	fill="currentColor"></path>
																<path fill-rule="evenodd" clip-rule="evenodd"
																	d="M.315 7.44a1.002 1.002 0 0 1 0-1.46L6.238.302a1.11 1.11 0 0 1 1.523 0c.421.403.421 1.057 0 1.46L1.838 7.44a1.11 1.11 0 0 1-1.523 0z"
																	fill="currentColor"></path>
																<path fill-rule="evenodd" clip-rule="evenodd"
																	d="M13.685 7.44a1.11 1.11 0 0 1-1.523 0L6.238 1.762a1.002 1.002 0 0 1 0-1.46 1.11 1.11 0 0 1 1.523 0l5.924 5.678c.42.403.42 1.056 0 1.46z"
																	fill="currentColor"></path>
															</svg>
														</div>
													</div>
												</div>
											</div>
										</div>
									</div>
								</div>
							</div>
							<div class="_0fcaa63 _7941d9f">内容由 AI 生成，请仔细甄别</div>
						</div>
					</div>
				</div>
				<!-- 对话列表 -->
				<div class="_765a5cd" v-if="talkList!=''">
					<div class="_2be88ba">
						<div class="f8d1e4c0">
							<div
								style="flex: 1 1 0%; min-width: 0px; display: flex; place-content: center; z-index: 12; margin-top: 10px;">
								<div class="d8ed659a" tabindex="0" style="outline: none;">{{chatTitle}}</div>
							</div>
							<div class="_62b4800"></div>
						</div>
						<!-- 移动端导航栏 -->
						<div class="_0efe408">
							
							<div class="ds-icon d7829b2f _2e7d873" style="font-size: 24px; width: 32px; height: 32px; color: rgb(139, 139, 139);"><svg width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M23.7222 4H4.27776C3.57207 4 3 4.57207 3 5.27776C3 5.98345 3.57207 6.55553 4.27776 6.55553H23.7222C24.4279 6.55553 25 5.98345 25 5.27776C25 4.57207 24.4279 4 23.7222 4Z" fill="currentColor"></path><path d="M14.7593 12.8887H4.27776C3.57207 12.8887 3 13.4607 3 14.1664C3 14.8721 3.57207 15.4442 4.27776 15.4442H14.7593C15.465 15.4442 16.037 14.8721 16.037 14.1664C16.037 13.4607 15.465 12.8887 14.7593 12.8887Z" fill="currentColor"></path><path d="M23.7222 21.7334H4.27776C3.57207 21.7334 3 22.3055 3 23.0112C3 23.7169 3.57207 24.2889 4.27776 24.2889H23.7222C24.4279 24.2889 25 23.7169 25 23.0112C25 22.3055 24.4279 21.7334 23.7222 21.7334Z" fill="currentColor"></path></svg></div>
							
							<div class="ds-icon d7829b2f _23ecf90" style="font-size: 24px; width: 32px; height: 32px; color: rgb(139, 139, 139);"><svg width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M9.10999 27C8.92999 27 8.76001 26.96 8.60001 26.9C8.43001 26.83 8.29 26.74 8.16 26.61C8.03 26.49 7.94 26.3499 7.87 26.1899C7.79999 26.0299 7.76001 25.8599 7.76001 25.6899L7.73001 23.04C7.34001 22.98 6.95001 22.8799 6.57001 22.7599C6.19001 22.6299 5.83001 22.48 5.48001 22.29C5.13001 22.1 4.79999 21.88 4.48999 21.63C4.17999 21.39 3.89 21.1199 3.63 20.82C3.37 20.52 3.13999 20.21 2.92999 19.87C2.72999 19.53 2.56001 19.18 2.42001 18.82C2.28001 18.45 2.17001 18.07 2.10001 17.69C2.03001 17.3 2 16.92 2 16.53V9.46995C2 9.03995 2.04 8.61995 2.12 8.19995C2.21 7.77995 2.34 7.36995 2.5 6.96995C2.67 6.57995 2.88 6.19995 3.12 5.84995C3.36 5.48995 3.64001 5.15995 3.95001 4.85995C4.26001 4.55995 4.59999 4.28995 4.95999 4.04995C5.32999 3.80995 5.70999 3.60995 6.10999 3.44995C6.51999 3.27995 6.94 3.15995 7.37 3.07995C7.79999 2.98995 8.23001 2.94995 8.67001 2.94995H13.3C13.46 2.94995 13.61 2.97995 13.76 3.03995C13.9 3.09995 14.03 3.17995 14.14 3.28995C14.25 3.39995 14.33 3.51995 14.39 3.65995C14.45 3.79995 14.48 3.94995 14.48 4.09995C14.48 4.25995 14.45 4.39995 14.39 4.54995C14.33 4.68995 14.25 4.80995 14.14 4.91995C14.03 5.02995 13.9 5.10995 13.76 5.16995C13.61 5.22995 13.46 5.25995 13.3 5.25995H8.67001C8.38001 5.25995 8.09999 5.27995 7.82999 5.33995C7.54999 5.38995 7.27999 5.46995 7.01999 5.57995C6.75999 5.67995 6.50999 5.80995 6.26999 5.96995C6.03999 6.11995 5.82 6.29995 5.62 6.48995C5.42 6.68995 5.23999 6.89995 5.07999 7.12995C4.92999 7.35995 4.78999 7.59995 4.67999 7.85995C4.57999 8.10995 4.49 8.37995 4.44 8.64995C4.38 8.91995 4.35999 9.18995 4.35999 9.46995V16.53C4.35999 16.81 4.38 17.08 4.44 17.36C4.5 17.63 4.58 17.9 4.69 18.16C4.8 18.42 4.93 18.67 5.09 18.9C5.25 19.13 5.43001 19.3499 5.64001 19.5499C5.84001 19.75 6.05999 19.92 6.29999 20.08C6.53999 20.24 6.79 20.37 7.06 20.47C7.32 20.58 7.6 20.66 7.88 20.72C8.16001 20.77 8.44001 20.7999 8.73001 20.7999C8.91001 20.7999 9.08 20.83 9.25 20.9C9.41 20.97 9.55999 21.0599 9.67999 21.18C9.80999 21.3099 9.91001 21.45 9.98001 21.61C10.05 21.77 10.08 21.94 10.09 22.11L10.1 23.74L13.08 21.61C13.84 21.07 14.69 20.7999 15.63 20.7999H19.32C19.61 20.7999 19.89 20.77 20.16 20.72C20.44 20.67 20.71 20.59 20.97 20.4799C21.23 20.3699 21.48 20.24 21.72 20.09C21.95 19.94 22.17 19.76 22.37 19.57C22.57 19.3699 22.75 19.16 22.91 18.93C23.07 18.7 23.2 18.46 23.31 18.2C23.41 17.95 23.5 17.68 23.55 17.41C23.61 17.14 23.63 16.87 23.63 16.59V12.94C23.63 12.79 23.66 12.64 23.72 12.5C23.78 12.36 23.87 12.23 23.98 12.13C24.09 12.02 24.22 11.93 24.36 11.88C24.51 11.82 24.66 11.79 24.82 11.79C24.97 11.79 25.12 11.82 25.27 11.88C25.41 11.93 25.54 12.02 25.65 12.13C25.76 12.23 25.85 12.36 25.91 12.5C25.97 12.64 26 12.79 26 12.94V16.59C26 17.02 25.95 17.44 25.87 17.86C25.78 18.28 25.66 18.69 25.49 19.08C25.32 19.48 25.11 19.8499 24.87 20.2099C24.63 20.57 24.35 20.9 24.04 21.2C23.73 21.5 23.39 21.7699 23.03 22.0099C22.67 22.2499 22.28 22.45 21.88 22.61C21.47 22.77 21.06 22.9 20.63 22.9799C20.2 23.07 19.76 23.11 19.32 23.11H16.4C15.47 23.11 14.62 23.3799 13.86 23.9199L9.91 26.74C9.67 26.91 9.39999 27 9.10999 27Z" fill="currentColor"></path><path d="M24.6805 5.14453H18.1874C17.5505 5.14453 17.0342 5.66086 17.0342 6.29778C17.0342 6.9347 17.5505 7.45102 18.1874 7.45102H24.6805C25.3175 7.45102 25.8338 6.9347 25.8338 6.29778C25.8338 5.66086 25.3175 5.14453 24.6805 5.14453Z" fill="currentColor"></path><path d="M22.6137 3.1804C22.6137 2.52848 22.0852 2 21.4333 2C20.7814 2 20.2529 2.52848 20.2529 3.1804V9.4168C20.2529 10.0687 20.7814 10.5972 21.4333 10.5972C22.0852 10.5972 22.6137 10.0687 22.6137 9.4168V3.1804Z" fill="currentColor"></path></svg></div>
						</div>
					</div>
					<div class="_3919b83">
						<div class="_8f60047" ref="container">
							<div class="_0f72b0b">
								<div class="dad65929">
									<!-- 用户发送的消息 -->
									<div :class="item.type==1?'_9663006':'_4f9bf79 _43c05b5'"
										v-for="(item,index) in talkList" :key="index">

										<div class="fbb737a4" v-if="item.type==1">{{item.msg}}
											<div class="ds-flex _78e0558"
												style="position: absolute; right: calc(100% + 18px); top: 12px; gap: 14px;">
												<div class="ds-icon-button" tabindex="0"
													style="--ds-icon-button-text-color: #909090; --ds-icon-button-size: 20px;">
													<div class="ds-icon"
														style="font-size: 20px; width: 20px; height: 20px;"></div>
												</div>
												<div class="ds-icon-button" tabindex="0"
													style="--ds-icon-button-text-color: #909090; --ds-icon-button-size: 20px;">
													<div class="ds-icon"
														style="font-size: 20px; width: 20px; height: 20px;"></div>
												</div>
											</div>
										</div>



										<div v-else>
											<div>
												<!-- <text space="nbsp" user-select="true">{{item.msg}}
													<text v-if="item.type==0 && !item.end" class="cursor">|</text>
												</text> -->

												<div class="_7eb2358 _58dfa60">
													<img :src="item.icon" />
												</div>
												<div class="ds-markdown ds-markdown--block" style="--ds-md-zoom: 1.143;"
													v-if="item.msg">
													<!-- <div ref="contentCopy">{{item.msg}}</div> -->
													<!-- style="white-space: pre-wrap;" -->
													<div ref="contentCopy" v-html="renderMarkdown(item.msg)"></div>
													<a class="adverBox" v-if="item.advert" :href="item.advert.url" target="_blank">
														<div class="adverTitle">{{item.advert.title}}</div>
														<img :src="item.advert.image" />
														<div class="advertBs">广告</div>
													</a>
													<!-- <p class="ds-markdown-paragraph">{{item.msg}}</p> -->
												</div>
												<div v-else style="display: flex;">
													<div>思考中...</div>
													<div class="ds-loading b4e4476b" style="font-size: 20px;"><svg viewBox="0 0 36 36" version="1.1" xmlns="http://www.w3.org/2000/svg" aria-hidden="true" data-icon="spin"><defs><linearGradient x1="0%" y1="100%" x2="100%" y2="100%" id="linearGradient-1"><stop stop-color="currentColor" stop-opacity="0" offset="0%"></stop><stop stop-color="currentColor" stop-opacity="0.50" offset="39.9430698%"></stop><stop stop-color="currentColor" offset="100%"></stop></linearGradient></defs><g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd"><rect fill-opacity="0.01" fill="none" x="0" y="0" width="36" height="36"></rect><path d="M34,18 C34,9.163444 26.836556,2 18,2 C11.6597233,2 6.18078805,5.68784135 3.59122325,11.0354951" stroke="url(#linearGradient-1)" stroke-width="4" stroke-linecap="round"></path></g></svg></div>
												</div>
												<div class="ds-flex"
													style="margin-top: 12px; height: 20px; align-items: center; gap: 10px;">
													<div class="ds-flex _965abe9" @click="copy(item.msg)" style="align-items: center; gap: 16px;">
														<div class="ds-icon-button" tabindex="0"
															style="--ds-icon-button-text-color: #909090; --ds-icon-button-size: 20px;">
															<div class="ds-icon"
																style="font-size: 20px; width: 20px; height: 20px;"><svg
																	width="24" height="24" viewBox="0 0 24 24"
																	fill="none" xmlns="http://www.w3.org/2000/svg">
																	<path
																		d="M3.65169 12.9243C3.68173 13.1045 3.74181 13.2748 3.80189 13.445C3.87198 13.6052 3.96211 13.7654 4.06225 13.9156C4.16238 14.0658 4.27253 14.206 4.4027 14.3362C4.52286 14.4663 4.66306 14.5765 4.81326 14.6766C4.96346 14.7768 5.11366 14.8569 5.28389 14.927C5.44411 14.9971 5.61434 15.0571 5.79459 15.0872C5.97483 15.1272 6.14506 15.1373 6.3253 15.1373V16.9196C6.30739 16.9196 6.28949 16.9195 6.27159 16.9193C5.9991 16.9158 5.72659 16.8859 5.4541 16.8295C5.16371 16.7694 4.88334 16.6893 4.61298 16.5692C4.3326 16.459 4.08226 16.3188 3.83193 16.1586C3.59161 15.9884 3.3613 15.7981 3.15102 15.5878C2.94074 15.3776 2.7605 15.1473 2.59027 14.9069C2.43006 14.6566 2.28986 14.3962 2.17972 14.1259C2.06957 13.8455 1.97944 13.5651 1.91936 13.2747C1.86929 12.9843 1.83926 12.684 1.83926 12.3936V6.26532C1.83926 5.96492 1.86929 5.67456 1.91936 5.38417C1.97944 5.09378 2.06957 4.80338 2.17972 4.53302C2.28986 4.26265 2.43006 4.0023 2.59027 3.75197C2.7605 3.50163 2.94074 3.27132 3.15102 3.06104C3.3613 2.85076 3.59161 2.67052 3.83193 2.50029C4.08226 2.33006 4.3326 2.19987 4.61298 2.07971C4.88334 1.96956 5.16371 1.87943 5.4541 1.81935C5.74449 1.75927 6.03491 1.73926 6.3253 1.73926H12.3934C12.6838 1.73926 12.9842 1.75927 13.2746 1.81935C13.555 1.87943 13.8354 1.96956 14.1158 2.07971C14.3861 2.19987 14.6465 2.33006 14.8868 2.50029C15.1371 2.67052 15.3574 2.85076 15.5677 3.06104C15.778 3.27132 15.9582 3.50163 16.1284 3.75197C16.2887 4.0023 16.4288 4.26265 16.539 4.53302C16.6592 4.80338 16.7393 5.09378 16.7994 5.38417C16.8558 5.65722 16.8858 5.93024 16.8892 6.21161C16.8894 6.22948 16.8895 6.24739 16.8895 6.26532H15.1271C15.1271 6.08508 15.1071 5.90486 15.067 5.72462C15.037 5.55439 14.9869 5.38415 14.9168 5.21392C14.8467 5.04369 14.7566 4.88347 14.6665 4.73327C14.5664 4.58307 14.4462 4.45289 14.326 4.32271C14.1959 4.19254 14.0557 4.08239 13.9055 3.98226C13.7553 3.88212 13.6051 3.79202 13.4348 3.72193C13.2746 3.65184 13.1044 3.60174 12.9242 3.5717C12.7539 3.53165 12.5737 3.51163 12.3934 3.51163H6.3253C6.14506 3.51163 5.97483 3.53165 5.79459 3.5717C5.61434 3.60174 5.44411 3.65184 5.28389 3.72193C5.11366 3.79202 4.96346 3.88212 4.81326 3.98226C4.66306 4.08239 4.52286 4.19254 4.4027 4.32271C4.27253 4.45289 4.16238 4.58307 4.06225 4.73327C3.96211 4.88347 3.87198 5.04369 3.80189 5.21392C3.74181 5.38415 3.68173 5.55439 3.65169 5.72462C3.61164 5.90486 3.60164 6.08508 3.60164 6.26532V12.3936C3.60164 12.5638 3.61164 12.744 3.65169 12.9243Z"
																		fill="currentColor"></path>
																	<path fill-rule="evenodd" clip-rule="evenodd"
																		d="M9.66972 21.6772C9.39936 21.567 9.13902 21.4268 8.8987 21.2566C8.64836 21.0964 8.42804 20.9061 8.21776 20.6959C8.00748 20.4856 7.81723 20.2553 7.65701 20.015C7.4968 19.7646 7.3566 19.5043 7.24646 19.2239C7.12629 18.9535 7.04621 18.6731 6.98613 18.3727C6.92605 18.0823 6.89601 17.792 6.89601 17.4915V11.3733C6.89601 11.0729 6.92605 10.7825 6.98613 10.4922C7.04621 10.1918 7.12629 9.91137 7.24646 9.64101C7.3566 9.36063 7.4968 9.10028 7.65701 8.85996C7.81723 8.60962 8.00748 8.37931 8.21776 8.16903C8.42804 7.95875 8.64836 7.76849 8.8987 7.60828C9.13902 7.43805 9.39936 7.29785 9.66972 7.1877C9.94009 7.07755 10.2205 6.98745 10.5108 6.92737C10.8012 6.86729 11.0916 6.83725 11.392 6.83725H17.4602C17.7506 6.83725 18.041 6.86729 18.3313 6.92737C18.6217 6.98745 18.9021 7.07755 19.1725 7.1877C19.4529 7.29785 19.7032 7.43805 19.9535 7.60828C20.1938 7.76849 20.4242 7.95875 20.6345 8.16903C20.8447 8.37931 21.025 8.60962 21.1952 8.85996C21.3554 9.10028 21.4956 9.36063 21.6058 9.64101C21.7159 9.91137 21.806 10.1918 21.8661 10.4922C21.9162 10.7825 21.9462 11.0729 21.9462 11.3733V17.4915C21.9462 17.792 21.9162 18.0823 21.8661 18.3727C21.806 18.6731 21.7159 18.9535 21.6058 19.2239C21.4956 19.5043 21.3554 19.7646 21.1952 20.015C21.025 20.2553 20.8447 20.4856 20.6345 20.6959C20.4242 20.9061 20.1938 21.0964 19.9535 21.2566C19.7032 21.4268 19.4529 21.567 19.1725 21.6772C18.9021 21.7973 18.6217 21.8774 18.3313 21.9375C18.041 21.9976 17.7506 22.0276 17.4602 22.0276H11.392C11.0916 22.0276 10.8012 21.9976 10.5108 21.9375C10.2205 21.8774 9.94009 21.7973 9.66972 21.6772ZM10.8613 8.6697C11.0316 8.63966 11.2118 8.61965 11.392 8.61965H17.4602C17.6404 8.61965 17.8107 8.63966 17.9909 8.6697C18.1611 8.70975 18.3314 8.75983 18.5016 8.82992C18.6618 8.90001 18.822 8.98012 18.9722 9.08026C19.1224 9.18039 19.2626 9.30055 19.3828 9.42071C19.513 9.55088 19.6231 9.69109 19.7232 9.84129C19.8234 9.99149 19.9035 10.1517 19.9736 10.3219C20.0437 10.4821 20.0937 10.6624 20.1338 10.8326C20.1638 11.0129 20.1838 11.1931 20.1838 11.3733V17.4915C20.1838 17.6718 20.1638 17.852 20.1338 18.0323C20.0937 18.2125 20.0437 18.3828 19.9736 18.543C19.9035 18.7132 19.8234 18.8734 19.7232 19.0236C19.6231 19.1738 19.513 19.314 19.3828 19.4342C19.2626 19.5643 19.1224 19.6845 18.9722 19.7846C18.822 19.8848 18.6618 19.9649 18.5016 20.035C18.3314 20.1051 18.1611 20.1551 17.9909 20.1952C17.8107 20.2252 17.6404 20.2452 17.4602 20.2452H11.392C11.2118 20.2452 11.0316 20.2252 10.8613 20.1952C10.6811 20.1551 10.5108 20.1051 10.3506 20.035C10.1804 19.9649 10.0202 19.8848 9.87 19.7846C9.72982 19.6845 9.58962 19.5643 9.45945 19.4342C9.33929 19.314 9.21913 19.1738 9.119 19.0236C9.01886 18.8734 8.93875 18.7132 8.86866 18.543C8.79857 18.3828 8.74847 18.2125 8.71843 18.0323C8.67838 17.852 8.65836 17.6718 8.65836 17.4915V11.3733C8.65836 11.1931 8.67838 11.0129 8.71843 10.8326C8.74847 10.6624 8.79857 10.4821 8.86866 10.3219C8.93875 10.1517 9.01886 9.99149 9.119 9.84129C9.21913 9.69109 9.33929 9.55088 9.45945 9.42071C9.58962 9.30055 9.72982 9.18039 9.87 9.08026C10.0202 8.98012 10.1804 8.90001 10.3506 8.82992C10.5108 8.75983 10.6811 8.70975 10.8613 8.6697Z"
																		fill="currentColor"></path>
																</svg></div>
														</div>

													</div>
													<div style="flex: 1 1 0%;"></div>
												</div>

											</div>


										</div>

									</div>


								</div>
								<div class="_88681e8">
									<div class="_217e214" @click="newChat">
										<svg width="18" height="18" viewBox="0 0 18 18" fill="none"
											xmlns="http://www.w3.org/2000/svg">
											<path
												d="M5.856 17.121a.979.979 0 0 1-.327-.06.839.839 0 0 1-.283-.177.739.739 0 0 1-.187-.255.724.724 0 0 1-.07-.303l-.02-1.609a4.663 4.663 0 0 1-1.446-.455 4.252 4.252 0 0 1-.637-.401c-.199-.146-.385-.31-.553-.492a4.442 4.442 0 0 1-.45-.577 4.303 4.303 0 0 1-.327-.637 3.823 3.823 0 0 1-.206-.686 3.729 3.729 0 0 1-.064-.704V6.478c0-.261.025-.516.077-.771a4.43 4.43 0 0 1 .244-.747 4.062 4.062 0 0 1 .932-1.28c.2-.183.418-.347.65-.493.23-.145.482-.267.739-.364a4.21 4.21 0 0 1 .81-.225c.27-.054.553-.078.835-.078H8.55c.103 0 .2.018.29.054a.7.7 0 0 1 .411.376.667.667 0 0 1-.161.766.736.736 0 0 1-.25.151.764.764 0 0 1-.29.055H5.573c-.186 0-.366.012-.54.049-.18.03-.353.079-.52.145-.167.061-.328.14-.482.237-.148.091-.29.2-.418.316a2.897 2.897 0 0 0-.347.388c-.097.14-.187.286-.257.444a2.473 2.473 0 0 0-.206.977v4.287c0 .17.013.333.051.503a2.549 2.549 0 0 0 .772 1.33 2.721 2.721 0 0 0 .913.559c.167.066.347.115.527.152.18.03.36.048.546.048a.904.904 0 0 1 .61.23.848.848 0 0 1 .194.262.84.84 0 0 1 .07.303l.007.99 1.915-1.293a2.877 2.877 0 0 1 1.64-.492h2.372c.186 0 .366-.018.54-.048.18-.03.353-.08.52-.146.168-.067.329-.146.483-.237.148-.091.29-.2.418-.316.128-.121.244-.249.347-.388a2.8 2.8 0 0 0 .257-.444 2.47 2.47 0 0 0 .206-.977V8.585a.646.646 0 0 1 .225-.492.679.679 0 0 1 .244-.152.814.814 0 0 1 .585 0c.09.03.174.085.244.152a.657.657 0 0 1 .225.492V10.8c0 .261-.032.516-.083.771a4.192 4.192 0 0 1-.245.74c-.109.244-.244.468-.398.687a3.735 3.735 0 0 1-.534.6c-.2.183-.418.347-.65.493a4.134 4.134 0 0 1-.738.364 4.7 4.7 0 0 1-.81.225c-.27.054-.553.079-.836.079h-1.877c-.604 0-1.144.164-1.633.491l-2.54 1.713a.913.913 0 0 1-.514.157z"
												fill="currentColor"></path>
											<path
												d="M15.866 4.125h-4.174c-.41 0-.741.313-.741.7 0 .387.332.7.741.7h4.174c.41 0 .742-.313.742-.7 0-.387-.332-.7-.742-.7z"
												fill="currentColor"></path>
											<path
												d="M14.537 2.932c0-.396-.34-.717-.759-.717s-.758.32-.758.717v3.786c0 .396.34.717.758.717.42 0 .76-.321.76-.717V2.932z"
												fill="currentColor"></path>
										</svg><span>开启新对话</span></div>
								</div>
								<div class="_871cbca">
									<div class="aaff8b8f">
										<div class="_0e98de6" @click="scrollToBottom">
											<svg xmlns="http://www.w3.org/2000/svg" width="16"
												height="9" viewBox="0 0 16 9" fill="none">
												<path fill-rule="evenodd" clip-rule="evenodd"
													d="M1.00008 2.41429C0.609551 2.02376 0.609551 1.3906 1.00008 1.00008C1.3906 0.609551 2.02376 0.609551 2.41429 1.00007L8.00008 6.58586L13.5859 1.00008C13.9764 0.609551 14.6096 0.609551 15.0001 1.00008C15.3906 1.3906 15.3906 2.02376 15.0001 2.41429L8.8486 8.56576C8.37997 9.03439 7.62018 9.03439 7.15155 8.56576L1.00008 2.41429Z"
													fill="currentColor"></path>
											</svg></div>
										<div class="_77cefa5">
											<div class="dd442025 _42b6996">
												<div class="_24fad49">
													<textarea id="chat-input" class="_27c9245" @keydown.enter="textEnter" placeholder="给 顶搜 发送消息 " v-model="content" rows="2"></textarea>
													<div class="b13855df">
													</div>
												</div>
												<div class="ec4f5d61">

													<div class="bf38813a">

														<!-- bcc55ca1样式不可点击 -->
														<div role="button" class="_7436101"
															:class="content!=''?'':'bcc55ca1'" @click="newOpen">
															<div class="_6f28693">
																<div class="ds-icon"
																	style="font-size: 16px; width: 16px; height: 16px;">
																	<svg width="14" height="16" viewBox="0 0 14 16"
																		fill="none" xmlns="http://www.w3.org/2000/svg">
																		<path fill-rule="evenodd" clip-rule="evenodd"
																			d="M7 16c-.595 0-1.077-.462-1.077-1.032V1.032C5.923.462 6.405 0 7 0s1.077.462 1.077 1.032v13.936C8.077 15.538 7.595 16 7 16z"
																			fill="currentColor"></path>
																		<path fill-rule="evenodd" clip-rule="evenodd"
																			d="M.315 7.44a1.002 1.002 0 0 1 0-1.46L6.238.302a1.11 1.11 0 0 1 1.523 0c.421.403.421 1.057 0 1.46L1.838 7.44a1.11 1.11 0 0 1-1.523 0z"
																			fill="currentColor"></path>
																		<path fill-rule="evenodd" clip-rule="evenodd"
																			d="M13.685 7.44a1.11 1.11 0 0 1-1.523 0L6.238 1.762a1.002 1.002 0 0 1 0-1.46 1.11 1.11 0 0 1 1.523 0l5.924 5.678c.42.403.42 1.056 0 1.46z"
																			fill="currentColor"></path>
																	</svg>
																</div>
															</div>
														</div>
													</div>
												</div>
											</div>
										</div>
									</div>
									<div class="_0fcaa63">内容由 AI 生成，请仔细甄别</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	// import { LoadingOutlined } from '@ant-design/icons'

	import {
		MenuFoldOutlined
	} from '@ant-design/icons';
	import {
		message
	} from 'ant-design-vue';
	import { marked } from 'marked';
	export default {
		// components:{LoadingOutlined},
		data() {
			return {
				showType: '1',
				chatId: '',
				talkList: [],
				hisList: [],
				chatTitle: '',
				// sendStatus: false,

				sendState: false,
				isTyping: false,
				currentMassage: {},
				currentIndex: 0,
				currentContent: '',
				currentAdver: '',
				typingInterval: 50,
				userInfo: null,
				imitateMsgList: [],
				imitateIndex: 0,

				// sendState:false,
				// isTyping:false,
				// currentMassage:{},
				// currentIndex:0,
				// currentContent:'',
				// imitateMsgList:[],
				// imitateIndex:0,
				// typingInterval:50,

				content: '',
				headImg: '',
				userName:'',
				navSta: true
			}

		},
		mounted() {
			this.getHis()
			if (!localStorage.getItem('token')) {
				this.$router.replace('/login')
				return
			}
			this.headImg = localStorage.getItem('headImg')
			this.userName = localStorage.getItem('userName')

		},
		methods: {
			scrollToBottom() {
			  this.$nextTick(() => {
			    const container = this.$refs.container; // 假设你的容器有一个ref="container"
			    container.scrollTop = container.scrollHeight;
			  });
			  
			},
			loginOut(){
				localStorage.clear()
				this.$router.replace('/login')
				message.info('已退出登录')
			},
			
			renderMarkdown(text) {
				// console.log(marked(text))
			  return marked(text); // 解析 Markdown 为 HTML
			},
			// async sendMsg() {
			// 	let that = this
			// 	if (that.content.trim()) {
			// 		const res = await that.request({
			// 			method: "post",
			// 			url: "https://ai.iptzx.com/api/index/chat",
			// 			headers: {
			// 				token: localStorage.getItem('token')
			// 			},
			// 			data: {
			// 				msg: that.content,
			// 				chat_id: that.chatId
			// 			}
			// 		})
			// 		console.log(res)
			// 		if (res.data.code == 1) {
			// 			that.talkList.push(res.data.data)
			// 			console.log(that.talkList)
			// 		} else {

			// 		}
			// 	}

			// },
			async getHis() {
				let that = this
				const res = await that.request({
					method: 'post',
					url: 'https://ai.iptzx.com/api/index/chatList',
					headers: {
						token: localStorage.getItem('token')
					},
					data: {}
				})
				console.log(res)
				that.hisList = res.data.data
			},
			async getChatDet(id, title) {
				let that = this
				const res = await that.request({
					method: 'post',
					url: 'https://ai.iptzx.com/api/index/chatLog',
					headers: {
						token: localStorage.getItem('token')
					},
					data: {
						chat_id: id
					}
				})
				console.log(res)
				that.talkList = res.data.data.reverse()
				that.chatTitle = title
				that.chatId = id
				that.scrollToBottom()
			},

			send(msg) {
				var that = this;
				// that.content = msg;
				if (this.sendState) {
					return false;
				}

				if (!that.content) {
					message.error('请输入内容')
					return false;
				}

				that.sendState = true;
				that.talkList.push({
					msg: that.content, // 消息内容
					type: 1, // 此为消息类别，设 1 为发出去的消息，2 为收到对方的消息,
					state: 1,
					// icon:(this.userInfo&&this.userInfo.icon?this.userInfo.icon:uni.getStorageSync('userInfo').avatar),
				})
				// that.content=''
				that.talkList.push({
					msg: '', // 消息内容
					type: 2, // 此为消息类别，设 1 为发出去的消息，2 为收到对方的消息,
					state: 0,
					end: false,
					icon: 'https://ai.iptzx.com/static/logo.png',
					advert: ''
				})
				// this.$forceUpdate()
				this.openChat()
				this.imitateIndex = 0;

				// this.toSend();

			},
			//textarea回车事件
			textEnter(e){
				this.newOpen()
				e.preventDefault()
			},
			//新请求接口
			newOpen(msg){
				console.log(msg)
				let that = this
				// that.content = msg
				if (this.sendState) {
					return false;
				}

				if (!that.content) {
					message.error('请输入内容')
					return false;
				}

				that.sendState = true;
				that.talkList.push({
					msg: that.content, // 消息内容
					type: 1, // 此为消息类别，设 1 为发出去的消息，2 为收到对方的消息,
					state: 1,
					// icon:(this.userInfo&&this.userInfo.icon?this.userInfo.icon:uni.getStorageSync('userInfo').avatar),
				})
				// that.content=''
				that.talkList.push({
					msg: '', // 消息内容
					type: 2, // 此为消息类别，设 1 为发出去的消息，2 为收到对方的消息,
					state: 0,
					end: false,
					icon: 'https://ai.iptzx.com/static/logo.png',
					advert: ''
				})
				
				that.scrollToBottom()
				var index = that.talkList.length - 1
				// this.$forceUpdate()
				const es = new EventSource('https://ai.iptzx.com/chat.php?token='+localStorage.getItem('token')+'&msg='+that.content+'&chat_id='+that.chatId+'', {
				  method: 'POST',
				  headers: {
				    'Content-Type': 'application/json'
				  },
				  body: JSON.stringify({
				    messages: [{role: "user", content: that.content}]
				  })
				});
				
				es.onmessage = e => {
					that.content=''
					that.talkList[index].msg+=JSON.parse(e.data).content
					// that.talkList[index].msg+= new TextDecoder().decode(JSON.parse(e.data).content)
					console.log(that.talkList[index].msg)
					that.scrollToBottom()
				};
				
				es.addEventListener('end', (e) => {
					// console.log(JSON.parse(e.data).advert)
					// that.content=''
					that.talkList[index].advert=JSON.parse(e.data).advert
					that.$data.sendState = false;
					that.chatId=JSON.parse(e.data).chat_id
				  es.close();
				});
			},
			
			//开启对话
			async openChat() {
				let that = this

				console.log(that.content)
				const res = await that.request({
					method: "post",
					url: "https://ai.iptzx.com/api/index/chat",
					headers: {
						token: localStorage.getItem('token')
					},
					data: {
						msg: that.content,
						chat_id: that.chatId
					}
				})
				console.log(res)
				console.log('---')
				if (res.data.code == 1) {
					res.data.data.type = 2
					console.log(res.data.data.type)
					that.imitateMsgList.push(res.data.data)
					// that.talkList.push(res.data.data)
					that.chatId = res.data.data.chat_id
					console.log(that.imitateMsgList)

				} else {
					that.imitateMsgList = [{
						is_end: true,
						result: res.msg
					}]
				}
				that.toSend();
				that.content = ''
				console.log(that.talkList)
			},
			// 发送信息
			toSend() {
				const that = this;
				var times = Math.floor(Math.random() * 2000) + 500;
				// 模拟接收消息
				setTimeout(function() {
					console.log(that.imitateIndex)
					that.currentMassage = that.imitateMsgList[that.imitateIndex];
					console.log(that.currentMassage)
					that.currentContent += that.currentMassage.result;
					that.currentAdver = that.currentMassage.advert;
					that.startTyping();
					if (that.imitateIndex >= that.imitateMsgList.length - 1) {
						that.imitateIndex = 0;
					} else {
						that.imitateIndex++;
						that.toSend();
					}
				}, times);

			},
			startTyping() {
				if (this.isTyping) return;
				var that = this;
				var index = that.talkList.length - 1
				this.isTyping = true;
				setTimeout(() => {
					if (this.currentIndex <= this.currentContent.length) {
						that.talkList[index].state = 1;
						that.talkList[index].type = 2;
						that.talkList[index].icon = 'https://ai.iptzx.com/static/logo.png';
						that.talkList[index].msg = this.currentContent.substring(0, this.currentIndex++);
						that.talkList[index].advert = this.currentAdver
						// that.$forceUpdate()
						// 	// 设置当前滚动的位置
						//that.setPageScrollTo();
						this.isTyping = false;
						this.startTyping();
					} else {
						if (that.currentMassage.is_end) {
							that.talkList[0].end = true;
							that.currentIndex = 0;
							that.currentContent = '';
							that.sendState = false;
						}
						this.isTyping = false;
					}
				}, this.typingInterval);
				that.imitateMsgList = []
			},
			async deleChat(id, index) {
				let that = this
				const res = await that.request({
					method: "post",
					url: "https://ai.iptzx.com/api/index/deleteChat",
					headers: {
						token: localStorage.getItem('token')
					},
					data: {
						chat_id: id
					}
				})
				console.log(res)
				if (res.data.code == 1) {
					that.hisList.splice(index, 1);
					message.success('删除成功')
				}
			},
			//开启新对话
			newChat(){
				if(this.chatId==''){
					message.info('当前已经是新对话')
					return
				}
				this.talkList=[]
				this.chatId=''
				this.content=''
			},
			// 复制当前内容
			async copy(data){
				// const content = this.$refs.contentCopy.innerText;
				//   const dummy = document.createElement('textarea');
				//   document.body.appendChild(dummy);
				//   dummy.value = content;
				//   dummy.select();
				//   document.execCommand('copy');
				//   document.body.removeChild(dummy);
				 //  const content = this.$refs.contentCopy.innerText;
				 //  console.log(content)
					// try {
					//   await navigator.clipboard.writeText(content);
					//   alert('内容已复制！');
					// } catch (err) {
					//   console.error('复制失败', err);
					//   alert('复制失败！');
					// }
				try {
				  await navigator.clipboard.writeText(data);
				  // alert("复制成功: " + data);
				  message.success('复制成功')
				} catch (err) {
				  console.error("复制失败:", err);
				}
			},
			// 跳转广告链接
			toPage(url){
				window.open(url)
			}

		}
	}
</script>

<style scoped>
	@import url('../../style/pub.css');
	/* 新增广告样式 */
	.adverBox{
		max-width: 100%;
		width: 240px;
		border: 1px solid #eee !important;
		padding: 4px;
		box-sizing: border-box;
		border-radius: 6px;
		margin-top: 20px;
		position: relative;
		display: block;
	}
	.adverBox .adverTitle
	{
		font-size: 14px;
		white-space: nowrap;
		overflow: hidden;
		text-overflow: ellipsis;
		color: #333;
	}
	.adverBox .advertBs
	{
		position: absolute;
		right: 10px;
		bottom: 10px;
		color: #fff;
		font-size: 10px;
		display: inline-block;
		border-radius: 20px;
		border: 1px solid #fff;
		height: 18px;
		line-height: 18px;
		padding: 0 6px;
	}
</style>